<template>
  <autocomplete v-model="searchQuery" :static-items="documentTypeItems" :options="options" :on-item-selected="onSearchItemSelected" :on-input-change="onInputChange" :required="required">
    <template #item="props">
      {{ props.item.text }}
    </template>
  </autocomplete>
</template>

<script>
import Autocomplete from '@/components/Autocompletes/Autocomplete'

/**
   * Static autocomplete for OCR Document Types. Options come from
   * `ecosystemConfig.geofenceOcrDocumentTypes` (a flat array). When `withUnknown`
   * is set, an extra "Unknown" option (not present in the config list) is added.
   * @displayName DocumentTypeAutocomplete
   */
export default {
  emits: ['selected'],
  name: 'DocumentTypeAutocomplete',
  components: {
    Autocomplete
  },
  props: {
    preQuery: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    withUnknown: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      searchQuery: '',
      selectedSearchItem: null,
      options: {
        debounce: 0,
        placeholder: this.placeholder,
        inputClass: 'form-control'
      }
    }
  },
  computed: {
    documentTypeItems() {
      const items = (this.$store.getters.ecosystemConfig?.geofenceOcrDocumentTypes || []).map((opt) => {
        if (opt && typeof opt === 'object') {
          return { text: opt.text ?? opt.value, value: opt.value ?? opt.text }
        }
        return { text: opt, value: opt }
      }).sort((a, b) => {
        return ('' + a.text).localeCompare('' + b.text)
      })
      if (this.withUnknown) {
        items.unshift({ text: this.$gettext('Unknown'), value: 'unknown' })
      }
      return items
    }
  },
  watch: {
    preQuery(val) {
      this.searchQuery = val || ''
    }
  },
  created() {
    if (!this.placeholder) {
      this.options.placeholder = this.$gettext('Type to search...')
    }
  },
  methods: {
    onInputChange(query) {
      const q = this.normalize(query)
      if (q.length === 0) {
        this.$emit('selected', null)
        return this.documentTypeItems
      }
      return this.documentTypeItems.filter((item) => {
        return this.normalize(item.text).includes(q)
      })
    },
    normalize(value) {
      // Treat spaces and underscores as interchangeable so e.g. "bill of lading"
      // matches "bill_of_lading".
      return ('' + (value || '')).trim().toLowerCase().replace(/[\s_]+/g, ' ')
    },
    onSearchItemSelected(item) {
      this.searchQuery = item.text
      this.selectedSearchItem = item
      this.$emit('selected', item)
    }
  }
}
</script>
